import React from 'react';

import classnames from 'classnames';
import lodash from 'lodash';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

import styles from './MultiSelectCheckbox.scss';

class MultiSelectCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: props.selectedOptions || [],
            selectAllChecked: false,
            options: [],
        };
        this.clearOptions = this.clearOptions.bind(this);
        this.toggleOption = this.toggleOption.bind(this);
        this.defaultValueIndicator = this.defaultValueIndicator.bind(this);
    }

    componentDidMount() {
        if (this.props.setNotification) {
            this.props.setNotification(this.clearOptions);
        }

        if (!lodash.isNil(this.props.options)) {
            this.setState({
                options: this.generateDropdownOptions(this.props.options),
                selectAllChecked:
                    this.state.selectedOptions.length > 0 &&
                    this.state.selectedOptions.length === this.props.options.length,
            });
        }
        this.toggleOption(this.props.selectedOptions);
    }

    componentDidUpdate(prevProps) {
        const nextOptions = this.props.options;
        const nextSelectedOptions = this.props.selectedOptions;

        if (!lodash.isNil(nextOptions) && prevProps.options !== nextOptions) {
            this.setState(
                {
                    selectAllChecked:
                        this.state.selectedOptions.length > 0 &&
                        this.state.selectedOptions.length === prevProps.options.length,
                },
                () => {
                    this.setState({
                        options: this.generateDropdownOptions(nextOptions),
                    });
                }
            );
        }

        if (
            !lodash.isNil(nextSelectedOptions) &&
            prevProps.selectedOptions !== nextSelectedOptions
        ) {
            this.setState({
                selectedOptions: nextSelectedOptions,
            });
        }
    }

    generateDropdownOptions(options) {
        let multiSelectOptions = [];
        if (this.props.isSelectAllRequired !== false) {
            if (this.state.selectAllChecked) {
                multiSelectOptions.push({ label: 'Deselect All', value: 'Deselect All' });
            } else {
                multiSelectOptions.push({ label: 'Select All', value: 'Select All' });
            }
        }

        return multiSelectOptions.concat(options);
    }

    isOptionSelected(targetOption, options) {
        return lodash.some(options, (option) => option.value === targetOption);
    }

    selectAllOptions() {
        const allOptions = this.state.options.filter((item) => item.value !== 'Select All');
        if (allOptions.length !== 0) {
            this.setState(
                {
                    selectedOptions: allOptions,
                    selectAllChecked: true,
                },
                () => {
                    this.props.onChanged(this.state.selectedOptions);
                    this.setState({
                        options: this.generateDropdownOptions(allOptions),
                    });
                }
            );
        }
    }

    clearOptions() {
        const allOptions = this.state.options.filter((item) => item.value !== 'Deselect All');
        this.setState(
            {
                selectedOptions: [],
                selectAllChecked: false,
            },
            () => {
                this.props.onChanged(this.state.selectedOptions);
                this.setState({
                    options: this.generateDropdownOptions(allOptions),
                });
            }
        );
    }

    toggleOption(checkedOptions) {
        if (this.isOptionSelected('Select All', checkedOptions)) {
            this.selectAllOptions();
        } else if (this.isOptionSelected('Deselect All', checkedOptions)) {
            this.clearOptions();
        } else {
            this.setState(
                {
                    selectedOptions: checkedOptions,
                    selectAllChecked: checkedOptions.length === this.props.options.length,
                },
                () => this.props.onChanged(this.state.selectedOptions)
            );
        }
    }

    defaultValueIndicator({ placeholderButtonLabel, value }) {
        if (!value) {
            return placeholderButtonLabel;
        }
        if (Array.isArray(value)) {
            if (value.length === 0) {
                return placeholderButtonLabel;
            }
            if (value.length === 1) {
                return value[0].label;
            }
            return `${value.length} selected`;
        }
        return value.label;
    }

    render() {
        const {
            placeholder = 'Select Tasks',
            searchBarPlaceholder = 'Search...',
            renderValueIndicator,
            className,
        } = this.props;

        const customStyles = {
            option: (provided, state) => {
                return {
                    ...provided,
                    color: state.data.isDisabled ? 'grey' : provided.color,
                    backgroundColor: state.data.isDisabled ? 'white' : provided.backgroundColor,
                };
            },
            groupHeading: (provided, state) => ({
                ...provided,
                color: 'black',
                textTransform: 'none',
                pointerEvents: 'none',
                backgroundColor: 'white',
            }),
        };

        return (
            <div className={classnames(styles.multiCheckboxSelectDropdown, className)} data-cy="MultiSelectCheckbox">
                <ReactMultiSelectCheckboxes
                    value={this.state.selectedOptions}
                    onChange={this.toggleOption}
                    placeholderButtonLabel={placeholder}
                    placeholder={searchBarPlaceholder}
                    options={this.state.options}
                    styles={customStyles}
                    getDropdownButtonLabel={renderValueIndicator || this.defaultValueIndicator}
                    onMenuClose={() => {
                        this.props.onMenuClose &&
                            this.props.onMenuClose(this.state.selectedOptions);
                    }}
                    data-cy="MultiSelectCheckbox-checkbox"
                />
            </div>
        );
    }
}

export default MultiSelectCheckbox;
